/**
 * Since current locale from business in nextjs is not match HTML lang-locale standard, we do some process for compatible with standard
 * ref: https://c1ey4wdv9g.larksuite.com/wiki/wikusCtEHKf3q4qR3VAHE16tBVe
 * @param locale current locale from nextjs
 * @returns format lang
 */
export const getSeoFormatLang = (locale: string) => {
  let formatLocale = locale;
  return formatLocale;
};
